import React from 'react'
import injectSheet from 'react-jss'
import styles from './school-files-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import SchoolFilesEntry from './school-files-entry/school-files-entry.container'

const SchoolFilesTable = ({ classes, schoolFiles }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.left}>Thumb</HeadCell>
        <HeadCell className={classes.left}>Date</HeadCell>
        <HeadCell className={classes.left}>Owner</HeadCell>
        <HeadCell className={classes.left}>Student</HeadCell>
        <HeadCell className={classes.left}>Age group</HeadCell>
        <HeadCell className={classes.titleCell}>Title</HeadCell>
        <HeadCell className={classes.center}>Type</HeadCell>
        <HeadCell className={classes.center}>Judgement</HeadCell>
        <HeadCell className={classes.center}>Conclusion</HeadCell>
        <HeadCell className={classes.center}>School exemplar</HeadCell>
      </tr>
    </thead>
    <tbody>
      {schoolFiles.map(schoolFile => (
        <SchoolFilesEntry key={schoolFile.id} id={schoolFile.id} />
      ))}
    </tbody>
  </Table>
)

export default injectSheet(styles)(SchoolFilesTable)
